import Box from '@mui/material/Box';
import { HeroSection } from '../components/sections/HeroSection';
import { PopularDestinationsSection } from '../components/sections/PopularDestinationsSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
// import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { TrustBar } from '../components/sections/TrustBar';
import { BecomeGuideSection } from '../components/sections/BecomeGuideSection';
import { MobileAppSection } from '../components/sections/MobileAppSection';
import {
  GuideRecruitmentCampaignLayer,
  LandingPageProvider,
} from '@/features/campaigns';

export function HomePage() {
  return (
    <LandingPageProvider>
      <Box
        sx={{
          width: '100%',
          overflowX: 'clip',
          '& section': { position: 'relative' },
        }}
      >
        <HeroSection />
        <PopularDestinationsSection />
        <TrustBar />
        <HowItWorksSection />
        {/* <TestimonialsSection /> */}
        <BecomeGuideSection />
        <MobileAppSection />
      </Box>
      <GuideRecruitmentCampaignLayer />
    </LandingPageProvider>
  );
}
